module.exports = __webpack_public_path__ + "img/file-icon-active-mobile.dd08e289.svg";